// @ts-nocheck
import React from "react";
import { NavLink } from "react-router-dom";
import { 
  LayoutDashboard, 
  Building2, 
  UserCog, 
  FileText, 
  MessageSquare, 
  ShieldCheck,
  Receipt,
  Activity,
  Archive // 🟢 Ícone para o Histórico
} from "lucide-react";

// IMPORTAÇÃO DA LOGO ÚNICA
import logoSidebar from "../../assets/images/Real-Beneficios-logosidebar.png"; 

const NavItem = ({ to, icon: Icon, text, onClick, end = false }) => {
  const brandColor = "#00a99d";

  return (
    <li>
      <NavLink
        to={to}
        end={end}
        onClick={onClick}
        className={({ isActive }) =>
          `flex items-center p-3 sm:p-3.5 text-sm font-medium rounded-xl transition-all duration-200 ${
            isActive
              ? "text-white shadow-md shadow-[#00a99d]/30"
              : "text-slate-500 hover:text-[#00a99d] hover:bg-teal-50"
          }`
        }
        style={({ isActive }) => (isActive ? { backgroundColor: brandColor } : {})}
      >
        <Icon className="h-5 w-5" />
        <span className="ml-3 tracking-wide">{text}</span>
      </NavLink>
    </li>
  );
};

const AdminSidebar = ({ isSidebarOpen, onToggleSidebar }) => {
  return (
    <>
      {/* OVERLAY MOBILE */}
      {isSidebarOpen && (
        <div
          onClick={onToggleSidebar}
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-30 lg:hidden transition-opacity"
        ></div>
      )}

      {/* SIDEBAR */}
      <aside
        className={`fixed top-0 left-0 z-40 w-64 h-screen bg-white border-r border-slate-200/60 flex flex-col flex-shrink-0 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:sticky lg:top-0 lg:h-screen lg:z-20 ${
          isSidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"
        }`}
      >
        {/* LOGO ÚNICA GIGANTE E ALINHADA */}
        <div className="h-[72px] flex items-center justify-start px-6 border-b border-slate-200/60 shrink-0 bg-white overflow-hidden">
          <img 
            src={logoSidebar} 
            alt="Real Benefícios" 
            className="h-10 sm:h-12 w-auto object-contain transition-all duration-300 drop-shadow-sm scale-150 origin-left ml-4"
          />
        </div>

        {/* NAVEGAÇÃO COM DIVISÓRIAS */}
        <nav className="p-4 flex-1 overflow-y-auto custom-scrollbar">
          <ul className="space-y-1">
            
            <div className="px-3 pt-4 pb-2 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
              Principal
            </div>
            
            <NavItem
              to="/super-admin"
              icon={LayoutDashboard}
              text="Dashboard"
              onClick={onToggleSidebar}
              end={true}
            />
            <NavItem
              to="/super-admin/requests"
              icon={FileText}
              text="Solicitações"
              onClick={onToggleSidebar}
            />
            <NavItem
              to="/super-admin/garantias-ativas"
              icon={ShieldCheck}
              text="Garantias Ativas"
              onClick={onToggleSidebar}
            />
            
            {/* 🟢 NOVO MENU: HISTÓRICO DE LOCAÇÕES (BLOCO 5) */}
            <NavItem
              to="/super-admin/historico"
              icon={Archive}
              text="Histórico de Locações"
              onClick={onToggleSidebar}
            />

            <NavItem
              to="/super-admin/faturamento"
              icon={Receipt}
              text="Faturamento (NF)"
              onClick={onToggleSidebar}
            />

            <NavItem
              to="/super-admin/modelos-parecer"
              icon={MessageSquare}
              text="Modelos de Parecer"
              onClick={onToggleSidebar}
            />
            
            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
              Gestão da Rede
            </div>
            
            <NavItem
              to="/super-admin/imobiliarias"
              icon={Building2}
              text="Imobiliárias"
              onClick={onToggleSidebar}
            />
            <NavItem
              to="/super-admin/equipe"
              icon={UserCog}
              text="Equipe Interna"
              onClick={onToggleSidebar}
            />

            {/* SESSÃO DO SISTEMA */}
            <div className="px-3 pt-8 pb-2 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
              Sistema
            </div>
            
            <NavItem
              to="/super-admin/health"
              icon={Activity}
              text="Saúde do Sistema"
              onClick={onToggleSidebar}
            />
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default AdminSidebar;